import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import { transportColumns } from '../DriverLogColumns';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { VEHICLES_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../../configs';
import { loadVehicleRegistryList } from '../../../VehicleRegistry/actions';
import { getVehicleRegistryData } from '../../../VehicleRegistry/reducer';
import getDefaultSort from '../../../../utils/getDefaultSort';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';

export function TransportBox(props) {
  const { driverId, onClose = () => {} } = props;
  const dispatch = useDispatch();
  const {
    vehicleRegistryList,
    loadingVehicleRegistryList,
    vehicleRegistryListMeta,
  } = useSelector(getVehicleRegistryData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VEHICLES_REGISTRY_MODULE].vehicleRegistryListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: {
        driver_id: driverId,
      },
      sort,
    };
    const p1 = dispatch(loadVehicleRegistryList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [sort, setSort] = useState(getDefaultSort(transportColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingVehicleRegistryList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.vehicle' })}</div>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={vehicleRegistryList}
            columns={transportColumns}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.TRANSPORT_DETAIL, id: item.id })));
            }}
            additionalColumns={[]}
            changeSort={changeSort}
            sort={sort}
            name="transport-list"
            settingsFormatter={moreFormatter}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={vehicleRegistryListMeta} list={vehicleRegistryList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
